import { createActionName } from "../../../utility"

export const reducerName = "files"

export const FILE = createActionName(reducerName, "FILE")
export const UPDATE_TEMP_URL = "_UPDATE_TEMP_URL"
export const DELETE_SELECTED_HASH = "_DELETE_SELECTED_HASH"
